export const FormMixin = {
  data () {
    return {
      title: '新增',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      editable: false,
      addable: false,
      showable: false,
      linkable: false,
      spAddable: false,
      distractable: false,
      apportionable: false,
      type: 'add'
    }
  },
  methods: {
    init (id, type, ...vars) {
      if (type && type === 'add') {
        this.addable = true
        this.type = type
        this.title = '新增'
      }
      if (type === 'edit') {
        this.editable = true
        this.type = type
        this.title = '修改'
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
        this.title = '查看'
      }
      if (type === 'link') {
        this.linkable = true
        this.type = type
        this.title = '关联'
      }
      if (type === 'removeLink') {
        this.linkable = true
        this.type = type
        this.title = '解除关联'
      }
      if (type === 'distract') {
        this.distractable = true
        this.type = type
        this.title = '转移'
      }
      if (type === 'apportion') {
        this.apportionable = true
        this.type = type
        this.title = '费用分摊'
      }
      // if (type === 'spAdd') {
      //   this.spAddable = true
      //   this.type = type
      //   this.title = '关联添加'
      // }
      this.edit(id, type, ...vars)
    },
    edit () {

    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
        this.linkable = false
        this.distractable = false
        this.apportionable = false
      }, 200)
    }
  }
}
